export default {
  namespaced: true,
  getters: {
    menu (state, getters, ___, globalGetters) {
      const notifications = globalGetters['auth/loggedInUser'].notification
      const links = [
        {
          id: 'fields',
          icon: 'pin',
          text: 'Площадки',
          to: '/'
        },
        {
          id: 'events',
          icon: 'calendar',
          text: 'События',
          to: '/events'
        },
        {
          id: 'moderations',
          icon: 'hand',
          text: 'Модерация',
          to: '/moderations'
        },
        {
          id: 'reports',
          icon: 'back',
          text: 'Жалобы',
          to: '/reports'
        },
        {
          id: 'users',
          icon: 'users',
          text: 'Пользователи',
          to: '/users'
        },
        {
          id: 'notifications',
          icon: 'bell',
          text: 'Уведомления',
          to: '/notifications',
          postscript: notifications
        },
        {
          id: 'schedule',
          icon: 'bell',
          text: 'График',
          to: '/schedule'
        }
      ]

      const roles = globalGetters['auth/loggedInUser'].role
      let formattedRoles = []
      let role = ''

      if (!roles) { return [] }

      if (Array.isArray(roles)) {
        formattedRoles = roles
      } else if (typeof roles === 'string') {
        formattedRoles = [roles]
      }

      if (formattedRoles.includes('ROLE_ADMIN')) {
        role = 'ROLE_ADMIN'
      } else if (formattedRoles.includes('ROLE_MANAGER')) {
        role = 'ROLE_MANAGER'
      }

      const menu = {
        ROLE_ADMIN: [
          'fields',
          'events',
          'moderations',
          'reports',
          'users',
          'notifications'
        ],
        ROLE_MANAGER: [
          'fields',
          'events',
          'schedule'
        ]
      }

      if (!menu[role]) {
        return []
      }

      return menu[role].map(item => {
        return links.find(link => {
          return link.id === item
        })
      })
    }
  }
}
